import {
    CART_ADD_ITEM,
    CART_REMOVE_ITEM,
    CART_SAVE_PAYMENT_METHOD,
    CART_SAVE_SHIPPING_ADDRESS
} from '../constants/CartConstants';
import axios from 'axios';
import { server_api } from './api';


export const addToCart = (id, qty) => async (dispatch, getState) => {

    const { data } = await axios.get(`${server_api}/api/products/${id}`)
    
    dispatch({
        type: CART_ADD_ITEM,
        payload: {
            creator: data.user._id,
            product: data._id,
            name: data.name,
            price: data.price,
            image: data.image,
            countInStock: data.countInStock,
            qty
        }
    })

    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
} 

export const saveShippingAddress = (data) => (dispatch) => {
    dispatch({
        type:CART_SAVE_SHIPPING_ADDRESS,
        payload: data
    })

    localStorage.setItem('shippingAddress', JSON.stringify(data))
}


export const savePaymentMethod = (data) => (dispatch) => {
    
    dispatch({
        type: CART_SAVE_PAYMENT_METHOD,
        payload: data
    })

    localStorage.setItem('paymentMethod', JSON.stringify(data))
}


export const removeFromCart = (id) => async (dispatch, getState) => {
    
    
    dispatch({
        type: CART_REMOVE_ITEM,
        payload: id
    })
    
    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
}
